import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("退运费");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("不退运费");

const _hoisted_3 = {
  key: 0,
  class: "tips red"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips red"
}, "请确保取消信息已告知发货方，否则可能造成损失。", -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "平台操作仅做数据矫正以确保数据统计正确，暂不支持直连发货方系统", -1);

const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch, nextTick } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import { getOrderDetail, cancelOrders } from '@/request';
export default {
  name: 'cancelOrderModal',
  props: {
    modelValue: Boolean,
    data: Object
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });
    const returnPostage = ref(0);
    const table = ref([]);
    const tableEl = ref();
    const deliveryText = ref('');
    watch(() => props.modelValue, v => {
      if (v) {
        returnPostage.value = 0;
        getList();
      }
    });

    function getList() {
      let params = {
        orderCode: props.data.order_code_split,
        prodCancalQuery: 1
      };
      getOrderDetail(params).then(res => {
        table.value = res.rows;
        deliveryText.value = res.deliveryText;
        nextTick(() => tableEl.value.toggleAllSelection());
      });
    }

    function submit() {
      if (!selectedList.value.length) {
        ElMessage.warning('请选择商品');
        return;
      }

      let status = selectedList.value[0].prodStatusText || props.data.order_state;
      let info = '';

      switch (status) {
        case '订单开票中':
        case '待出库':
          info = '，已推送至发货方系统，请确保信息已告知发货方。';
          break;

        case '正在出库':
          info = '，库房可能已准备货物，请确保信息已告知发货方。';
          break;

        case '部分出库':
          info = '，货物可能正在配送或已送至客户，请确保信息已告知发货方。';
          break;

        default:
          break;
      }

      ElMessageBox.confirm(`订单“${status}”${info}`, '请选择取消类型', {
        type: 'warning',
        cancelButtonText: '暂不取消',
        confirmButtonText: '我已告知发货方'
      }).then(() => {
        let body = {
          orderCodeSplit: props.data.order_code_split,
          detailIds: selectedList.value.map(v => v.detailId)
        };
        let canCancelTotal = table.value.filter(v => v.canCheck == 1).length;
        body.isAllCancel = canCancelTotal == selectedList.value.length ? 1 : 0;
        body.returnPostage = returnPostage.value;
        cancelOrders(body).then(res => {
          let {
            success,
            msg
          } = res;

          if (success) {
            ElMessage.success('操作成功');
            visible.value = false;
            emit('success');
          } else {
            ElMessage.error(msg);
          }
        });
      });
    }

    const selectedList = ref([]);

    function selectable(row) {
      // let { prodStatusText } = row
      // if (prodStatusText.includes('已取消') || prodStatusText.includes('已出库')) return false
      // return true
      return row.canCheck == 1;
    }

    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "请选择取消的商品",
        "custom-class": "cancel-order-modal",
        width: "1000px",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: returnPostage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => returnPostage.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: 1
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_radio, {
            label: 2
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), returnPostage.value === 1 && deliveryText.value !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(deliveryText.value), 1)) : _createCommentVNode("", true), _hoisted_4, _hoisted_5, _createVNode(_component_el_table, {
          data: table.value,
          onSelectionChange: _cache[1] || (_cache[1] = list => selectedList.value = list),
          ref_key: "tableEl",
          ref: tableEl
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55",
            selectable: selectable
          }), _createVNode(_component_el_table_column, {
            label: "状态",
            prop: "prodStatusText",
            width: "80"
          }), _createVNode(_component_el_table_column, {
            label: "操作人",
            prop: "cancelBy"
          }), _createVNode(_component_el_table_column, {
            label: "药品名称",
            prop: "prodName"
          }), _createVNode(_component_el_table_column, {
            label: "生产厂家",
            prop: "manufacture"
          }), _createVNode(_component_el_table_column, {
            label: "药品编码",
            prop: "prodNo",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            label: "药品规格",
            prop: "proSpec"
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};